var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalVehIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.5C18.3807 20.5 19.5 19.3807 19.5 18C19.5 16.6193 18.3807 15.5 17 15.5C15.6193 15.5 14.5 16.6193 14.5 18C14.5 19.3807 15.6193 20.5 17 20.5Z",
    fill: "#6929E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.5C8.38071 20.5 9.5 19.3807 9.5 18C9.5 16.6193 8.38071 15.5 7 15.5C5.61929 15.5 4.5 16.6193 4.5 18C4.5 19.3807 5.61929 20.5 7 20.5Z",
    fill: "#6929E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H12C13.1046 3 14 3.89543 14 5V6H17.0387C17.9501 6 18.812 6.41427 19.3814 7.12592L22.3426 10.8275C22.7682 11.3594 23 12.0203 23 12.7016V17C23 18.1046 22.1046 19 21 19H20.667C20.7537 18.6814 20.8 18.3461 20.8 18C20.8 15.9013 19.0987 14.2 17 14.2C14.9013 14.2 13.2 15.9013 13.2 18C13.2 18.3461 13.2463 18.6814 13.333 19H10.667C10.7537 18.6814 10.8 18.3461 10.8 18C10.8 15.9013 9.09868 14.2 7 14.2C4.90132 14.2 3.2 15.9013 3.2 18C3.2 18.3461 3.24627 18.6814 3.33295 19H3C1.89543 19 1 18.1046 1 17V5ZM19.9194 11L17.8196 8.3753C17.6298 8.13809 17.3425 8 17.0387 8H14.6257L15.864 10.451C16.0342 10.7877 16.3793 11 16.7566 11H19.9194Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVehIc);
export default __webpack_public_path__ + "static/media/total_veh_ic.8bbcfa1d8fb2a8db69c4be99383c9886.svg";
export { ForwardRef as ReactComponent };